// app/javascript/controllers/cookie_banner_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["banner"]

    connect() {
        // Initialiser le Consent Mode immédiatement
        this.initializeConsentMode()
        
        if (!this.hasAcceptedCookies()) {
            this.showBanner()
        } else if (this.getCookieConsent()) {
            this.grantConsent()
        }
    }

    accept() {
        this.setAnalyticsCookie()
        this.setFunctionalCookies()
        this.hideBanner()
        this.grantConsent()
    }

    reject() {
        this.removeAnalyticsCookies()
        this.setCookie('_ga_consent', 'false')
        this.hideBanner()
        this.denyConsent()
    }

    // Initialisation du Consent Mode
    initializeConsentMode() {
        if (typeof gtag !== 'undefined') {
            gtag('consent', 'default', {
                'analytics_storage': 'denied',
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            })
        }
    }

    // Accorder le consentement
    grantConsent() {
        if (typeof gtag !== 'undefined') {
            gtag('consent', 'update', {
                'analytics_storage': 'granted',
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted'
            })
        }
        
        this.initializeCustomTracking()
    }

    // Refuser le consentement
    denyConsent() {
        if (typeof gtag !== 'undefined') {
            gtag('consent', 'update', {
                'analytics_storage': 'denied',
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied'
            })
        }
    }

    // Domaine racine pour partager les cookies entre sous-domaines
    // go4school.net → .go4school.net, lvh.me → .lvh.me
    rootDomain() {
        const parts = window.location.hostname.split('.')
        return `.${parts.slice(-2).join('.')}`
    }

    setCookie(name, value) {
        const expires = new Date()
        expires.setFullYear(expires.getFullYear() + 1)
        document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=${this.rootDomain()}; SameSite=Lax`
    }

    deleteCookie(name) {
        const domain = this.rootDomain()
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`
    }

    // Gestion des cookies
    setAnalyticsCookie() {
        this.setCookie('_ga_consent', 'true')
        this.setCookie('_gtag_consent', 'true')
    }

    setFunctionalCookies() {
        this.setCookie('user_preferences', 'true')
        this.setCookie('session_consent', 'true')
    }

    removeAnalyticsCookies() {
        const analyticsKeys = ['_ga', '_ga_', '_gid', '_gat', '_gtag', '_ga_consent', '_gtag_consent']
        analyticsKeys.forEach(key => this.deleteCookie(key))

        // Supprimer les cookies avec pattern _ga_*
        const cookies = document.cookie.split(';')
        cookies.forEach(cookie => {
            const cookieName = cookie.split('=')[0].trim()
            if (cookieName.startsWith('_ga') || cookieName.startsWith('_gid') || cookieName.startsWith('_gat')) {
                this.deleteCookie(cookieName)
            }
        })
    }

    initializeCustomTracking() {
        const event = new CustomEvent('tracking:initialized', {
            detail: { consent: true }
        })
        window.dispatchEvent(event)
    }

    // Helpers
    showBanner() {
        this.bannerTarget.classList.remove('hidden')
    }

    hideBanner() {
        this.bannerTarget.classList.add('hidden')
    }

    hasAcceptedCookies() {
        return this.getCookie('_ga_consent') !== null
    }

    getCookieConsent() {
        return this.getCookie('_ga_consent') === 'true'
    }

    getCookie(name) {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(';').shift()
        return null
    }
}